import React, { FC } from 'react';
import clsx from 'clsx';
import { Box, CircularProgress } from '@material-ui/core';

import '../progress.scss';
import useResultsProgressContext from '../ResultsProgress/context/ResultsContext';

const ResultsProgress: FC = () => {
  const { visibility } = useResultsProgressContext();
  const classes = clsx({
    'Box-progress': true,
    'resultsProgress': true,
    'show': visibility,
    'hide': !visibility,
  });

  return (
    <Box className={classes}>
      <CircularProgress className="CircularProgress-spinner" />
    </Box>
  );
};

export default ResultsProgress;
